import { render } from "./MobileHeader.vue?vue&type=template&id=54a5c26c&scoped=true"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"

import "./MobileHeader.vue?vue&type=style&index=0&id=54a5c26c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54a5c26c"

export default script